// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2hT2j","inner":"Footer_inner__26wbn","nextIcon":"Footer_nextIcon__27y2E","innerLeft":"Footer_innerLeft__3m6-F"};